export default {
  buy_desc_1: '1000개 이상의 블록체인 지원',
  buy_desc_2: 'BTC, ETH, TRON, BSC 및 EVM 퍼블릭 체인 포함',
  buy_desc_3: '하나의 기기로 모든 크립토 자산 관리',

  features: '특징',
  features_title_1: 'MCU+SE 보안 칩',
  features_desc_1: '밀리터리 등급 칩으로 보안 보장',
  features_title_2: '2.0인치 LCD 스크린',
  features_desc_2: '더 많은 거래 상세, 보이는 그대로 서명',
  features_title_3: '블루투스 연결',
  features_desc_3: '비식별(탈감작) 통신',
  features_title_4: '다중 보호',
  features_desc_4: '오프라인, PIN 코드, 식별된 연결',
  color: '색상',
  free_shipping: '무료 배송',

  break_down_desc_1: '왼쪽 버튼',
  break_down_desc_2: '화면에서 왼쪽으로 이동하거나 이전 페이지로 돌아가기',
  break_down_desc_3: 'OK 버튼',
  break_down_desc_4: '동작 확인 또는 메뉴 진입, 길게 눌러 전원 켜기/끄기',
  break_down_desc_5: '위쪽 버튼',
  break_down_desc_6: '화면에서 위로 이동',
  break_down_desc_7: '오른쪽 버튼',
  break_down_desc_8: '화면에서 오른쪽으로 이동하거나 동작 확인',
  break_down_desc_9: '아래 버튼',
  break_down_desc_10: '화면에서 아래로 이동',

  display_title: '디스플레이',
  display_desc: '2인치 LCD 디스플레이',
  battery_title: '배터리',
  battery_desc: '100mAh',
  materials_title: '재질',
  materials_desc: '알루미늄 합금',
  dual_chip_title: '듀얼 칩',
  dual_chip_desc: 'MCU + SE 보안 칩',

  easy_and_safe_title: '쉽고 안전하게',
  easy_and_safe_desc: '쉽게 연결하고 사용하며, 자산을 안전하게 보호',
  easy_and_safe_list_1: '듀얼 칩',
  easy_and_safe_list_2: 'MCU + SE 보안 칩',
  easy_and_safe_list_3: '간편 연결',
  easy_and_safe_list_4: 'Bluetooth 및 Type-C',
  easy_and_safe_list_5: '2인치 디스플레이',
  easy_and_safe_list_6: '보이는 그대로 서명',

  product_specifications: '제품 사양',
  detail_center: 'USB Type-C',
  detail_left_1: '알루미늄 합금 케이스로 지갑을 손상으로부터 보호',
  detail_left_2: '왼쪽 버튼',
  detail_left_3: '아래 버튼',
  detail_right_1: '2인치 디스플레이로 관련 거래 표시',
  detail_right_2: '위쪽 버튼',
  detail_right_3: '오른쪽 버튼',
  detail_right_4: 'OK 버튼',

  keypal_card_1: '크기',
  keypal_card_label_1: '91mm*55mm*6.7mm',
  keypal_card_2: '전원 및 배터리',
  keypal_card_label_2: '100mAh 리튬이온 배터리',
  keypal_card_3: '연결',
  keypal_card_label_3: 'Bluetooth & Type-C',
  keypal_card_4: '재질',
  keypal_card_label_4: '알루미늄 합금, 플라스틱',
  keypal_card_5: '무게',
  keypal_card_label_5: '53g',
  keypal_card_6: '디스플레이',
  keypal_card_label_6: '2인치 LCD 디스플레이',
  keypal_card_7: '칩',
  keypal_card_label_7: 'MCU+SE',
  keypal_card_8: '인증',
  keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

  package: '패키지 구성',
  package_line_1: '하드웨어 월렛 1개',
  package_line_2: 'USB Type-C 케이블 1개',
  package_line_3: '복구 시트 2매',
  package_line_4: '스티커 1매',

  keypal_plus: {
    larger_battery: '배터리 용량 200% 증가',

    keypal_card_1: '크기',
    keypal_card_label_1: '91mm*55mm*9.0mm',
    keypal_card_2: '전원 및 배터리',
    keypal_card_label_2: '300mAh 리튬이온 배터리',
    keypal_card_3: '연결',
    keypal_card_label_3: 'Bluetooth & Type-C',
    keypal_card_4: '재질',
    keypal_card_label_4: '알루미늄 합금, 플라스틱',
    keypal_card_5: '무게',
    keypal_card_label_5: '63g',
    keypal_card_6: '디스플레이',
    keypal_card_label_6: '2인치 LCD 디스플레이',
    keypal_card_7: '칩',
    keypal_card_label_7: 'MCU+SE',
    keypal_card_8: '인증',
    keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

    color: '색상',
    color_desc: '블랙, 실버, 골드',
    battery: '배터리',
    battery_desc: '300 mAh',
    left: '왼쪽',
    down: '아래',
    right: '오른쪽',
    up: '위',
    ok: 'OK',
    center: 'USB Type-C',
    left_1: '왼쪽 버튼',
    left_2: '화면에서 왼쪽으로 이동하거나 이전 페이지로 돌아가기',
    left_3: '아래 버튼',
    left_4: '화면에서 아래로 이동',
    right_1: '위쪽 버튼',
    right_2: '화면에서 위로 이동',
    right_3: '오른쪽 버튼',
    right_4: '화면에서 오른쪽으로 이동하거나 동작 확인',
    right_5: 'OK 버튼',
    right_6: '동작 확인 또는 메뉴 진입, 길게 눌러 전원 켜기/끄기',
    mobile_center: 'Type-C',
    mobile_center_2: '충전 및 펌웨어 업그레이드용',
  },
};
